import factory from './icon';
import UncheckedSvg from './glyphs/checkbox_unchecked.svg';
import CheckedSvg from './glyphs/checkbox_checked.svg';

export const Unchecked = factory(UncheckedSvg);
export const Checked = factory(CheckedSvg);
